(function (module) {
    'use strict';

    function appTileCtrl() {
    }

    module
        .component('appTile', {
            templateUrl: '/js/components/app-tile/app-tile.html',
            controller: appTileCtrl,
            bindings: {
                slug: '<',
                styles: '<',

                //
                isIntegration: '<',
                isAppTemplate: '<',
                isAppInstance: '<',
                isCustomAppTemplate: '<',

                // title
                titleShow: '<',
                titleName: '<',
                titleFallback: '<',

                // logo
                logoShow: '<',

                version: '<',
                deployMethod: '<',

                // add
                addIcon: '@',
                addClick: '&',

                // edit
                editIcon: '@',
                editClick: '&',

                // delete
                deleteIcon: '@',
                deleteClick: '&',

                // delete
                cloneIcon: '@',
                cloneClick: '&',

                // preview
                overlayShow: '<',
                overlayText: '@',
                overlayClick: '&',

                beta: '<',


                // select
                checked: '<',
                isChecked: '&',
                selectable: '<',


            }
        });
})(angular.module('rocket.components'));
